export default __webpack_public_path__ + "static/media/ei3 Corporation.f6b7c273.png";